import { render, staticRenderFns } from "./NoticeIntro.vue?vue&type=template&id=7668e4a4&scoped=true"
import script from "./NoticeIntro.vue?vue&type=script&lang=js"
export * from "./NoticeIntro.vue?vue&type=script&lang=js"
import style0 from "./NoticeIntro.vue?vue&type=style&index=0&id=7668e4a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7668e4a4",
  null
  
)

export default component.exports